"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Scanner = void 0;
var Token_1 = require("./Token");
var ROW_DELIMITER = /((?:\r\n)|\n|\r)/;
var Scanner = /*#__PURE__*/function () {
  function Scanner(args) {
    _classCallCheck(this, Scanner);
    _defineProperty(this, "line", void 0);
    _defineProperty(this, "parserOptions", void 0);
    _defineProperty(this, "lineLength", void 0);
    _defineProperty(this, "hasMoreData", void 0);
    _defineProperty(this, "cursor", 0);
    this.line = args.line;
    this.lineLength = this.line.length;
    this.parserOptions = args.parserOptions;
    this.hasMoreData = args.hasMoreData;
    this.cursor = args.cursor || 0;
  }
  return _createClass(Scanner, [{
    key: "hasMoreCharacters",
    get: function get() {
      return this.lineLength > this.cursor;
    }
  }, {
    key: "nextNonSpaceToken",
    get: function get() {
      var lineFromCursor = this.lineFromCursor;
      var regex = this.parserOptions.NEXT_TOKEN_REGEXP;
      if (lineFromCursor.search(regex) === -1) {
        return null;
      }
      var match = regex.exec(lineFromCursor);
      if (match == null) {
        return null;
      }
      var token = match[1];
      var startCursor = this.cursor + (match.index || 0);
      return new Token_1.Token({
        token: token,
        startCursor: startCursor,
        endCursor: startCursor + token.length - 1
      });
    }
  }, {
    key: "nextCharacterToken",
    get: function get() {
      var cursor = this.cursor,
        lineLength = this.lineLength;
      if (lineLength <= cursor) {
        return null;
      }
      return new Token_1.Token({
        token: this.line[cursor],
        startCursor: cursor,
        endCursor: cursor
      });
    }
  }, {
    key: "lineFromCursor",
    get: function get() {
      return this.line.substr(this.cursor);
    }
  }, {
    key: "advancePastLine",
    value: function advancePastLine() {
      var match = ROW_DELIMITER.exec(this.lineFromCursor);
      if (!match) {
        if (this.hasMoreData) {
          return null;
        }
        this.cursor = this.lineLength;
        return this;
      }
      this.cursor += (match.index || 0) + match[0].length;
      return this;
    }
  }, {
    key: "advanceTo",
    value: function advanceTo(cursor) {
      this.cursor = cursor;
      return this;
    }
  }, {
    key: "advanceToToken",
    value: function advanceToToken(token) {
      this.cursor = token.startCursor;
      return this;
    }
  }, {
    key: "advancePastToken",
    value: function advancePastToken(token) {
      this.cursor = token.endCursor + 1;
      return this;
    }
  }, {
    key: "truncateToCursor",
    value: function truncateToCursor() {
      this.line = this.lineFromCursor;
      this.lineLength = this.line.length;
      this.cursor = 0;
      return this;
    }
  }]);
}();
exports.Scanner = Scanner;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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